import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-214">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-navy-900/80 backdrop-blur-sm z-50" data-id="element-215" />
          <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-216">
            <div className="bg-white text-navy-900 w-full max-w-2xl max-h-[85vh] rounded-2xl shadow-2xl flex flex-col pointer-events-auto" data-id="element-217">
              <div className="flex justify-between items-center p-6 border-b border-gray-200" data-id="element-218">
                <h2 className="font-heading font-bold text-2xl" data-id="element-219">{title}</h2>
                <button onClick={onClose} className="text-gray-500 hover:text-navy-900 transition-colors p-2 rounded-full hover:bg-gray-100" data-id="element-220">
                  <XIcon className="h-6 w-6" data-id="element-221" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto leading-snug space-y-4 text-gray-700" data-id="element-222">
                {children}
              </div>
              <div className="p-6 border-t border-gray-200 bg-gray-50 rounded-b-2xl flex justify-end" data-id="element-223">
                <button onClick={onClose} className="px-6 py-2 bg-navy-900 text-white font-bold rounded-lg hover:bg-navy-800 transition-colors" data-id="element-224">
                  Close
                </button>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}